import { getWidgetConfig } from '@/config'

type ChatEnabledSettings = {
  enabled?: boolean | null
  recommendationSettings?: {
    enabled?: boolean | null
  }
  chatSettings?: {
    enabled?: boolean | null
  }
}

// Flip to true when Chat AI launches for existing Terpli tenants.
// Explicit chatSettings.enabled is unchanged either way.
export const DEFAULT_CHAT_ON_FOR_TERPLI = true

// Pixel /aiq-sdk/widget/enabled chatEnabled=false (no AI addendum, or
// explicit off) always hides chat. Unset follows Terpli only after
// DEFAULT_CHAT_ON_FOR_TERPLI is flipped on. Explicit chatSettings.enabled
// still wins when spawn chatEnabled is not false.
export function resolveChatEnabled(
  settings?: ChatEnabledSettings | null,
  spawnChatEnabled: boolean | null | undefined = getWidgetConfig()?.chatEnabled
): boolean {
  if (spawnChatEnabled === false) return false
  const saved = settings?.chatSettings?.enabled
  if (saved === true) return true
  if (saved === false) return false
  if (spawnChatEnabled === true) return true
  if (!DEFAULT_CHAT_ON_FOR_TERPLI) return false
  return settings?.enabled === true || settings?.recommendationSettings?.enabled === true
}
